document.addEventListener('DOMContentLoaded', function(){
    scrollNav();
    fixedNavBar();
});

function fixedNavBar(){
    const navbar = document.querySelector('.header');   

    //Definir IntersectionOfServer
    const observer = new IntersectionObserver(function(entries){
        if(entries[0].isIntersecting){
            navbar.classList.remove('fixNavbar');
        } else {
            navbar.classList.add('fixNavbar');
        }
        
    });
    

    //Elemento a Observar
    observer.observe(document.querySelector('.video'));
}

function scrollNav(){
    const enlaces = document.querySelectorAll('.navegacionPrincipal a');
    enlaces.forEach(function(enlace){
        enlace.addEventListener('click', function(e){
            e.preventDefault();
            const section = document.querySelector(e.target.attributes.href.value);   
            section.scrollIntoView({
                behavior:'smooth'
            });         
        });
    });
}